import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import humanFormat from 'human-format';
import * as styles from './AudienceCard.scss';
var numberFormatScale = new humanFormat.Scale({
  '': 1,
  k: 1000,
  M: 1000000,
  B: 1000000000,
  T: 1000000000000
});

var AudienceCard = function AudienceCard(_ref) {
  var audience = _ref.audience,
      colors = _ref.colors,
      breakPointsWrap = _ref.breakPointsWrap,
      handleEdit = _ref.handleEdit,
      handleDelete = _ref.handleDelete,
      handleDuplicate = _ref.handleDuplicate,
      isAudienceCard = _ref.isAudienceCard;
  var audienceDefDict = {};

  if (audience && audience.targetingSentences) {
    audience.targetingSentences.forEach(function (a) {
      audienceDefDict[a.content] = a.children;
    });
  }

  var locations = audienceDefDict['Location - Living In:'] ? audienceDefDict['Location - Living In:'] : [];
  var excludedLocations = audienceDefDict['Exclude Location:'] ? audienceDefDict['Exclude Location:'] : [];
  var genders = audienceDefDict['Gender:'] ? audienceDefDict['Gender:'] : [];
  var age = audienceDefDict['Age:'] ? audienceDefDict['Age:'] : '';
  var adPlacements = audienceDefDict['Placements:'] ? audienceDefDict['Placements:'] : [];
  var includedInterestLines = audienceDefDict['People Who Match:'] ? audienceDefDict['People Who Match:'] : [];
  var andIncludedInterestLines = audienceDefDict['And Must Also Match:'] ? audienceDefDict['And Must Also Match:'] : [];
  var excludedLines = audienceDefDict['Exclude:'] ? audienceDefDict['Exclude:'] : [];
  return /*#__PURE__*/React.createElement("div", {
    className: breakPointsWrap ? styles.breakPointsWrap : styles.basicWrap
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.name,
    style: {
      color: colors.secondaryColor
    }
  }, audience.name), /*#__PURE__*/React.createElement("div", {
    className: styles.iconWrap
  }, handleDelete && /*#__PURE__*/React.createElement("i", {
    className: "icon ion-ios-trash-outline ".concat(styles.editButton),
    onClick: function onClick() {
      return handleDelete(audience);
    },
    style: {
      color: '#616161',
      cursor: 'pointer',
      fontSize: 22
    }
  }), handleEdit && /*#__PURE__*/React.createElement("i", {
    className: "icon ion-edit ".concat(styles.editButton),
    onClick: function onClick() {
      return handleEdit(audience);
    },
    style: {
      color: '#a1a1a1',
      cursor: 'pointer',
      fontSize: 21,
      marginRight: 24
    }
  }), handleDuplicate && /*#__PURE__*/React.createElement("i", {
    className: "icon ion-ios-copy ".concat(styles.editButton),
    onClick: function onClick() {
      return handleDuplicate(audience);
    },
    style: {
      color: '#a1a1a1',
      cursor: 'pointer',
      fontSize: 21,
      marginRight: 24
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      clear: 'both',
      display: 'flex',
      marginTop: 36
    }
  }, audience && audience.reachEstimate && audience.reachEstimate.users && audience.reachEstimate.users !== -1 && /*#__PURE__*/React.createElement("span", {
    className: styles.audienceNumber
  }, humanFormat(audience.reachEstimate.users, {
    scale: numberFormatScale
  })), isAudienceCard && /*#__PURE__*/React.createElement("ul", {
    className: styles.audienceList
  }, locations.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: styles.listLabel
  }, "Location - Living In:"), locations.join(', ')), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: styles.listLabel
  }, "Age:"), age || "".concat(age, " - ").concat(age)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: styles.listLabel
  }, "Gender:"), genders.length ? genders.map(function (g) {
    return g === 'Male' ? 'Men' : 'Women';
  }).join(', ') : 'Everyone'), adPlacements.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: styles.listLabel
  }, "Placements:"), adPlacements.join(', ')), includedInterestLines.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: styles.listLabel
  }, "People Who Match:"), includedInterestLines.join(', ')), andIncludedInterestLines.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: styles.listLabel
  }, "AND Must Also Match:"), andIncludedInterestLines.join(', ')), excludedLines.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: styles.listLabel
  }, "Exclude:"), excludedLines.join(', ')), excludedLocations.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: styles.listLabel
  }, "Exclude Location:"), excludedLocations.join(', ')))), audience && audience.reachEstimate && audience.reachEstimate.valid === false && /*#__PURE__*/React.createElement("span", {
    style: {
      textAlign: 'center',
      color: '#ff3500',
      marginTop: 10,
      display: 'inline-block'
    }
  }, "Audience Error:", ' ', audience.reachEstimate.error ? audience.reachEstimate.error : 'This targeting is invalid. It must be edited before it can be used in an ad.'));
};

AudienceCard.defaultProps = {
  audience: null,
  breakPointsWrap: false,
  handleEdit: null,
  handleDelete: null,
  isAudienceCard: true
};
export default AudienceCard;